<template>
  <div class="dataloggerManage">
    <div v-if="$store.state.device.isShow == 1" class="section">
      <div class="search">
        <div style="display:flex;">
          <div class="statusName">{{ $t('datalogger.Status') }}</div>
          <li class="statusList" @click="activeClass(value, key)" :class="activeIf == key ? 'active' : ''"
            v-for="(value, key) in statusList" :key="key">
            {{ value.label }}
          </li>
        </div>
        <!-- {{$t('datalogger.Datalogger_Status')+'：'}} -->
        <!-- 原 -->
        <!-- <el-select
          v-model="search.status"
          clearable
          @change="getDataloggerList(true)"
          :placeholder="this.$t('datalogger.Datalogger_Status')"
          popper-class="select-search-recharge"
          class="selectClearNew"
        >
          <el-option
            v-for="(value,key) in status"
            :key="key"
            :value="key"
            :label="value.label"
            style="display:flex;padding-left:40px;align-items:center;"
          >
            <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${value.name}`"></i>
            <span class="select-label">{{value.label}}</span>
          </el-option>
        </el-select> -->
        <!-- 改 -->
        <!-- <div>
          <span class="search-label">{{$t('datalogger.Datalogger_Status')}}</span>
          <el-select
            v-model="search.status"
            clearable
            @change="getDataloggerList(true)"
            :placeholder="$t('header.pleaseSelect')"
            popper-class="select-search-recharge"
            class="selectClearNew"
          >
            <el-option
              v-for="item in statusList"
              :key="item.num"
              :value="item.num"
              :label="item.label"
            >
              <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${item.name}`"></i>
              <span class="select-label">{{item.label}}</span>
            </el-option>
          </el-select>
        </div> -->


        <div sytle="display:flex;justify-content:flex-end;">
          <!-- 搜索 -->
          <!-- showSearch = true; -->
          <el-button class="searchButton button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <!-- v-clickoutside="closeSearch2" -->
          <div class="search-alert" v-if="this.$store.state.user.role != 2 && showSearch">
            <!-- :placeholder="$t('recharge.pn')" -->
            <!-- v-model="inputText" -->
            <!-- @input实时查询 -->
            <!-- @keyup.enter.native -->
            <div class="searchDiv">
              <el-input class="searchAll" ref="iptFocus" v-model.trim="search.alias"
                @keyup.enter.native="queryGetDataloggerList()" :placeholder="this.$t('header.pnAndAlias')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="queryGetDataloggerList()">{{ $t('recharge.Search') }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
            </div>
          </div>
          <div class="search-alert1" v-if="this.$store.state.user.role == 2 && showSearch">
            <div class="searchDiv">
              <el-input class="searchAll" ref="iptFocus" v-model.trim="search.alias"
                @keyup.enter.native="queryGetDataloggerList()" :placeholder="this.$t('header.pnAndAlias')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="queryGetDataloggerList()">{{ $t('recharge.Search') }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
            </div>
          </div>
          <!-- 批量操作 -->
          <!-- selectedplant.length -->
          <!-- <div class="batch-alert" v-show="true">
            <span>{{`当前选中 ${selectedplant.length} 条数据`}}}</span>
            <span class="batch-operate">
              <span class="batch-cell">
                <span class="">删除</span>
                <i class=""></i>
              </span>
            </span>
          </div> -->

          <!-- <button
            style="float: right;"
            class="button-solid button"
            @click="dialogDataloggerVisible=true"
          >{{$t('datalogger.add_datalogger')}}</button>-->
          <!-- 导出 -->
          <!-- <button
            style="float: right;margin-right:10px;"
            class="button"
            :class="pagination.total ? 'button-solid' : 'button-disable'"
            @click="exportPlant('all')"
          >{{$t('report.all_reports')}}</button> -->
          <!-- <button
            style="float: right;margin-right:10px;"
            :class="selectedplant.length ? 'button-solid' : 'button-disable'"
            @click="exportPlant(selectedplant)"
          >{{$t('report.Batch_export')}}</button> -->

          <!-- 添加数采器(经销商有，管理员无) -->
          <!-- <button
            v-if="this.$store.state.user.role==2"
            type="button" 
            class="button-addscq"
            @click="dialogDataloggerVisible=true"
            style="margin-right:1px"
          >
            <span>{{$t('datalogger.addScq')}}</span>
            <i class="iconfont icon-biaogegongneng_xinjian"></i>
          </button> -->
          <button v-if="this.$store.state.user.role == 2&&this.$store.state.user.addCollectorPermissions" type="button" class="button-addscq" @click="dialogAddScqClick()"
            style="margin-right:1px">
            <span>{{ $t('datalogger.addScq') }}</span>
            <i class="iconfont icon-biaogegongneng_xinjian"></i>
          </button>
          <!-- 批量添加数采器 -->
          <button v-if="this.$store.state.user.role == 2&&this.$store.state.user.addCollectorPermissions" type="button" class="button-addscq"
            @click="clickBatchCollector()">
            <span>{{ $t('datalogger.batchAddScq') }}</span>
            <i class="iconfont icon-biaogegongneng_xinjian"></i>
          </button>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <!-- v-show="showBatch" -->
        <!-- v-show="selectedplant.length" -->
        <!-- v-show="false" -->
        <div class="batch-alert" v-show="selectedplant.length">
          <!-- 当前选中条数 -->
          <span class="batch-total">
            {{ `${$t('alarm.curSelected')} ${selectedplant.length} ${$t('alarm._Data')}` }}
          </span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 导出 -->
              <!-- <span 
                class="btn"
                @click="exportPlant(selectedplant)"
              >
                {{$t('report.Export')}}
                <i class="ico ico-export"></i>
              </span> -->
              <!-- v-if="this.$store.state.user.role==1" -->
              <!-- 批量升级记录 -->
              <span v-if="this.$store.state.user.role == 1" class="btn" @click="queryUpgradeDatalogger(selectedplant1)">
                {{ $t('device.queryUpgrade') }}
                <i class="ico el-icon-search"></i>
              </span>
              <!-- 升级(管理员可批量升级) -->
              <span v-if="this.$store.state.user.role == 1" class="btn" @click="upgradeDataloggerBatch(selectedplant)">
                {{ $t('device.upgrade') }}
                <i class="ico ico-upgrade"></i>
              </span>
              <!-- 删除(暂时注释，接口待开发) -->
              <!-- <span 
                class="btn"
                @click="deleteDatalogger(selectedplant)"
              >
                {{$t('device.delete')}}
                <i class="ico ico-clear"></i>
              </span> -->
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{ $t('rate.cancel') }}</span>
          </div>
        </div>
      </div>
      <el-table :data="dataloggerList" stripe border height="100%" v-loading="loadingDatalogger"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" element-loading-spinner="el-icon-loading"
        @selection-change="changeFun" class="tablemain tableloding" :empty-text="$t('account.nodata')"
        ref="multiplePnTable" :cell-class-name="addClass1">
        <el-table-column fixed type="selection"></el-table-column>
        <el-table-column fixed min-width="135px;" :show-overflow-tooltip="true"
          :label="this.$t('datalogger.Datalogger_PN')">
          <template slot-scope="scope">
            <span class="redirect" @click="clickClosepage(scope.row)">
              {{ scope.row.pn }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true" :label="this.$t('datalogger.Datalogger_Name')">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            <span>{{ scope.row.alias || scope.row.pn }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" min-width="120px;" :show-overflow-tooltip="true"
          :label="this.$t('datalogger.Status')">
          <template slot-scope="scope">
            <div :class="`background-${status[scope.row.status].name}`" style="border-radius: 5px;">
              <span :class="`radius-${status[scope.row.status].name}`" style="width: 8px;height: 8px;border-radius: 8px;display: inline-block;margin-right: 5px;"></span>
              <span v-if="scope.row.status !== undefined" :class="`color-${status[scope.row.status].name}`">{{
              status[scope.row.status].label||"--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="descx" min-width="135px;" :show-overflow-tooltip="true"
          :label="this.$t('datalogger.Datalogger_type')">
          <template slot-scope="scope">
            <span>{{ scope.row.descx || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.User_belong')">
          <template slot-scope="scope">
            <span class="redirect" @click="enterDevice(scope.row)">{{ scope.row.usr || '--'}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="balance"
          width="120px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.Communication_balance')"
        ></el-table-column> -->
        <el-table-column prop="load" min-width="70px;" :show-overflow-tooltip="true"
          :label="this.$t('datalogger.load')"></el-table-column>
        <el-table-column min-width="145px;" :show-overflow-tooltip="true" :label="this.$t('datalogger.Firmware_Version')">
          <template slot-scope="scope">
            <span>{{ scope.row.fireware || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="145px;" :show-overflow-tooltip="true" :label="this.$t('datalogger.timeZone')">
          <template slot-scope="scope">
            <span>{{ filterTimeZone(scope.row.timeZone) || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="145px;" :show-overflow-tooltip="true" :label="this.$t('datalogger.activeStatus')">
          <template slot-scope="scope">
            <span v-if="scope.row.activationStatus==1">{{$t('datalogger.Active')}}</span>
            <span v-if="scope.row.activationStatus==0">{{$t('datalogger.notActive')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="signal" width="85px;" :show-overflow-tooltip="true" :label="this.$t('datalogger.signal')">
          <template slot-scope="scope">
            <signal :strength="scope.row.signal"></signal>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('datalogger.Operation')" width="240" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('datalogger.edit')" @click="editDatalogger(scope.row)">
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('datalogger.reboot')"
              @click="rebootDatalogger(scope.row)">
              <i class="iconfont icon-a-mingchengkaiguanji"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('datalogger.debug')"
              @click="debugDatalogger(scope.row)">
              <i class="iconfont icon-caozuo_tiaoshi"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('datalogger.upgrade')"
              @click="upgradeDatalogger(scope.row)">
              <i class="iconfont icon-shengji"></i>
            </el-button>
            <!-- 解绑 -->
            <el-button v-if="$store.state.user.role == 1" :disabled="scope.row.usr ? false : true" type="text"
              class="operation" :class="{ 'operation1': scope.row.usr == undefined }" :title="$t('datalogger.unbind')"
              @click="unbindDatalogger(scope.row.pn)">
              <i class="iconfont icon-a-mingchengyonghushuxingshanchu2"></i>
            </el-button>
            <!-- 重置 -->
            <el-button v-if="$store.state.user.role == 1"
              :disabled="(scope.row.usr == undefined && scope.row.status != 0) ? false : true" type="text"
              class="operation" :class="(scope.row.usr == undefined && scope.row.status != 0) ? '' : 'operation1'"
              :title="$t('datalogger.reset')" @click="resetDatalogger(scope.row.pn)">
              <i class="iconfont icon-a-mingchengzhongzhiyangshidansexianxingtubiao1"></i>
            </el-button>
            <el-button v-if="$store.state.user.role == 2" type="text" class="operation" :title="$t('datalogger.delete')"
              @click="deleteDatalogger(scope.row.pn)">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty">
          <img src="@/assets/img/empty_text.png" />
          <div style="line-height: 32px">{{$t('account.nodata')}}</div>
        </div> -->
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div class="" style="margin-left:10px;">
          <!-- 批量导出 -->
          <!-- <button
            type="button" 
            style="height:32px;margin-right:8px;"
            class="btn"
            :class="selectedplant.length ? 'btn-dark' : 'btn-disable'"
            @click="exportPlant(selectedplant)"
          >{{$t('report.Batch_export')}}</button> -->
          <!-- 批量删除 -->
          <!-- <button
            type="button" 
            style="height:32px;margin-right:8px;"
            class="btn"
            :class="selectedplant.length ? 'btn-dark' : 'btn-disable'"
            @click="deleteDatalogger(selectedplant)"
          >{{$t('alarm.Delete_selected')}}</button> -->
        </div>
        <!-- 分页 -->
        <!-- v-show="paginationControl" -->
        <el-pagination class="pagination" background @size-change="getDataloggerList(true)"
          @current-change="() => getDataloggerList()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <devicebelong v-if="$store.state.device.isShow == 2"></devicebelong>
    <collectorUpgrade v-if="$store.state.device.isShow == 3"></collectorUpgrade>
    <dataloggerDebug v-if="$store.state.device.isShow == 4"></dataloggerDebug>
    <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>
    <!-- 调试数采器 -->
    <!-- v-if="debugDataloggerVisible" -->
    <control-dialog :title="$t('datalogger.datalogger_debug')"
      :class="{ 'showDialog': debugDataloggerVisible, 'hideDialog': !debugDataloggerVisible }"
      :visible.sync="debugDataloggerVisible" noFooter>
      <div slot="content">
        <el-form class="grid">
          <el-form-item :label="$t('datalogger.communication_address')" size="small">
            <el-input type="number" v-model="datalogger.devaddr" auto-complete="off"  oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
          </el-form-item>
          <el-form-item :label="$t('datalogger.Instruction')" size="small">
            <el-input v-model="devDebug.cmd" :placeholder="$t('datalogger.such_as')" type="textarea"
              auto-complete="off"></el-input>
          </el-form-item>
          <!-- 发送指令 -->
          <el-form-item label=" ">
            <div style="text-align:right;">
              <button type="primary" class="btn btn-dark" @click="submitDebugDatalogger()">{{ $t('datalogger.send')
              }}</button>
            </div>
          </el-form-item>
          <!-- <el-form-item :label="$t('datalogger.return_content')" size="small">
            <el-input readonly v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('datalogger.return_content')" size="small">
            <div class="debug-return">
              <!-- id="link" -->
              <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
              <div class="return-tool">
                <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                  data-clipboard-target="#link">
                  <i class="ico ico-copy"></i>
                  {{ $t('device.copy_val') }}
                </span>
                <span class="btn" @click="qingkong()">
                  <i class="ico ico-clear"></i>
                  {{ $t('device.clear_val') }}
                </span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- <button 
				  class="button-hollow" 
					@click="qingkong()"
				>{{$t('datalogger.clear_data')}}</button> -->
        <!-- <button
          class="button-solid"
          type="primary"
          @click="submitDebugDatalogger()"
        >{{$t('datalogger.send')}}</button> -->
      </div>
    </control-dialog>

    <!-- 固件升级 -->
    <!-- v-if="upgradeDataloggerVisible" -->
    <control-dialog :title="$t('firmware.firmware_upgrade')"
      :class="{ 'showDialog': upgradeDataloggerVisible, 'hideDialog': !upgradeDataloggerVisible }"
      :visible.sync="upgradeDataloggerVisible" width="580px" noFooter>
      <div slot="content">
        <el-form class="grid upload-container upgradeNew"  element-loading-spinner="el-icon-loading" v-loading="loadingupgradeDatalogger">
          <!-- 批量升级提示(注意国际化) -->
          <el-form-item label=" ">
            <!-- 注意：批量升级是给多个数采器升级同一个数采器固件，如不清楚数采器所适合的固件，请谨慎选择！ -->
            <span v-if="upgradeDataloggerBatchSign == true" style="color:rgba(255, 62, 62, 1);font-size:14px;">{{
              $t('datalogger.upBatchDataloggerTip') }}</span>
          </el-form-item>
          <el-form-item :label="$t('datalogger.select_firmware')" size="small">
            <el-select v-model="searchrecharge" @change="voltageArr($event)" :placeholder="$t('datalogger.select_file')"
              popper-class="select-search-recharge select-search-project">
              <template slot="empty">
                <div style="text-align:right;">
                  <!-- <button type="button" class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') -->
                  <button type="button" class="upFirewareBtn"  @click="uploadFirmwareAdd()">{{ $t('firmware.Upload_firmware')
                  }}</button>
                </div>
              </template>
              <div style="text-align:right;">
                <!-- <button type="button" class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') -->
                <button type="button" class="upFirewareBtn"  @click="uploadFirmwareAdd()">{{ $t('firmware.Upload_firmware')
                }}</button>
              </div>
              <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <div class="processstatue" v-show="progressUp">{{ $t('firmware.upgrading') }}</div>
            <div class="processstatue" v-show="progerssComplete">{{ $t('firmware.updateCompleted') }}</div>
            <!-- 原上传按钮 -->
            <!-- <div class="upload-contents">
              <button class="upload-button" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                {{$t('datalogger.Upload')}}
              </button>
              <div class="upload-tip">{{$t('firmware.limit')}}</div>
            </div> -->
            <div class="progressShow" v-show="progressUp">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel" @click="upgradeCancel">
                <i class="iconfont icon-delete"></i>
              </div>
            </div>
            <div class="processData" v-show="progressUp">
              <el-progress :format="progressText" :percentage="progress" :stroke-width="10" color="#33FFB6"></el-progress>
              <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div>
            </div>
            <!-- 原上传按钮 -->
            <!-- <input
              type="file"
              class="upload-input"
              ref="fileUploader"
              accept="application/octet-stream"
              @change="uploadfile($event)"
            /> -->
            <!-- 批量时显示 -->
            <div class="progerssComplete" v-show="upgradeDataloggerBatchSign == true">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <!-- <div class="progressCancel"></div> -->
              <!-- 增：已完成升级的数采器PN(注意国际化) -->
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-start;">
                <div>
                  <!-- 升级成功的数采器： -->
                  <div style="color:#16D09A;">{{ $t('datalogger.upSuccessDatalogger') }}</div>
                  <div>
                    <span v-for="(item, index) in pnUpOkList" :key="index" style="
                                margin-right:5px;max-height: 100px;max-width: 200px;overflow: hidden;
                                overflow-y: scroll; display: flex;flex-direction: column;
                              ">{{ `${item},` }}</span>
                  </div>
                </div>
                <div style="margin-left:10px;">
                  <!-- 升级失败的数采器： -->
                  <div style="color:rgb(255, 62, 62);">{{ $t('datalogger.upFailDatalogger') }}</div>
                  <div>
                    <span v-for="(item, index) in pnUpNoList" :key="index" style="
                                margin-right:5px;max-height: 100px;max-width: 200px;overflow: hidden;
                                overflow-y: scroll; display: flex;flex-direction: column;
                              ">{{ `${item},` }}</span>
                  </div>
                </div>
              </div>
              <!-- 固件名称(上面已存在) -->
              <!-- <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{firmwareName}}
              </div> -->
              <!-- <div class="progressCancel"></div> -->
            </div>
            <!-- 单个时显示 -->
            <!-- v-show="progerssComplete" -->
            <div class="progerssComplete" v-show="progerssComplete && upgradeDataloggerBatchSign != true">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel"></div>
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <!-- 批量升级 -->
          <button v-if="upgradeDataloggerBatchSign == true" type="button" class="btn btn-dark"
            @click="submitUpgradeDataloggerBatch">{{ $t('datalogger.confirm') }}.</button>
          <!-- 单个升级 -->
          <!-- <button v-else type="button" class="btn btn-dark" @click="submitUpgradeDatalogger">{{ $t('datalogger.confirm')
          }}</button> -->
          <el-button v-else class="elbtn btn-dark" :disabled="upgradebButtonStatus"  @click="submitUpgradeDatalogger">{{ $t('datalogger.confirm') }}</el-button>
        </div>
      </div>
      <div slot="footer">
        <!-- <button
            class="button-hollow"
            @click="upgradeDataloggerVisible = false"
        >{{$t('datalogger.cancel')}}</button>-->
        <!-- <button 
				  class="button-solid" 
					@click="submitUpgradeDatalogger"
				>{{$t('datalogger.confirm')}}</button> -->
      </div>
    </control-dialog>
    <!-- 固件升级二次弹窗（增加固件的对话框） -->
    <!-- style="z-index:2014!important;" -->
    <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
    <update-dialog :title="$t('firmware.Upload_firmware')" :visible.sync="dialogAdd" v-if="dialogAdd" width="40vw"
      noFooter style="z-index:3000;">
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('browse.desc')" size="small">
            <el-input v-model="remark" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="dialogAdd = false">{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </update-dialog>
    <!-- 升级结果提示(成功) -->
    <!-- v-if="upgradeDeviceSucVisible" -->
    <control-dialog :title="$t('project.upgradeResults')" :visible.sync="upgradeDeviceSucVisible"
      :class="{ 'showDialog': upgradeDeviceSucVisible, 'hideDialog': !upgradeDeviceSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('project.upgradeSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="upgradeDeviceSucVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 升级结果提示(失败) -->
    <!-- v-if="upgradeDeviceFailVisible" -->
    <control-dialog :title="$t('project.upgradeResults')" :visible.sync="upgradeDeviceFailVisible"
      :class="{ 'showDialog': upgradeDeviceFailVisible, 'hideDialog': !upgradeDeviceFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="upgradeDeviceFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>

    <!-- 删除数采器 -->
    <!-- :title="$t('device.deleteDevice')" -->
    <!-- v-if="deletingDataloggerId" -->
    <!-- @submitSucDel="handleDelSuc" -->
    <control-dialog :title="$t('datalogger.deleteTitle')" :visible.sync="deletingDataloggerId"
      :class="{ 'showDialog': deletingDataloggerId, 'hideDialog': !deletingDataloggerId }" width="30vw" noFooter>
      <div slot="content">
        <!-- <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;">{{$t('datalogger.confirm_deldte')}}</span>
        </div> -->
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.confirm_deldte') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.deletingDataloggerId }}</span>
        </div>
        <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode" :placeholder="$t('datalogger.please_title')"></el-input>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="deletingDataloggerId = null">{{ $t('device.cancel') }}</button>
          <button style="background:#DD6843;" class="btn btn-dark" @click="submitDeleteDatalogger()">{{
            $t('datalogger.delete') }}</button>
        </div>
        <!-- <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{$t('account.notRecovered')}}</span>
        </div> -->
        <!-- <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="submitDeleteDatalogger">{{$t('datalogger.confirm')}}</button>
          <button type="button" class="btn btn-light" @click="deletingDataloggerId = null">{{$t('datalogger.cancel')}}</button>
        </div> -->
      </div>
    </control-dialog>
    <!-- 删除数采器结果提示(成功) -->
    <!-- v-if="dataloggerDelSucVisible" -->
    <control-dialog :title="$t('datalogger.delResults')" :visible.sync="dataloggerDelSucVisible"
      :class="{ 'showDialog': dataloggerDelSucVisible, 'hideDialog': !dataloggerDelSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.deleteSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerDelSucVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 删除数采器结果提示(失败) -->
    <!-- v-if="dataloggerDelFailVisible" -->
    <control-dialog :title="$t('datalogger.delResults')" :visible.sync="dataloggerDelFailVisible"
      :class="{ 'showDialog': dataloggerDelFailVisible, 'hideDialog': !dataloggerDelFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerDelFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>

    <!-- <div class="section-bottom"> -->
    <!-- <button :class="selectedplant.length ? 'button-solid' : 'button-disable'" @click="exportPlant(selectedplant)">批量导出</button> 
    <button class="button" :class="pagination.total ? 'button-solid' : 'button-disable'" @click="exportPlant('all')">导出所有</button>-->
    <!-- 数采器对应设备表弹窗 -->
    <!-- v-if="previewDataloggerInfo" -->
    <!-- :title="previewDataloggerInfo.alias" -->
    <control-dialog :visible.sync="previewDataloggerInfo"
      :class="{ 'showDialog': previewDataloggerInfo, 'hideDialog': !previewDataloggerInfo }" width="75vw" height="50vh"
      class="datalogger-device scqsbAlert" noFooter>
      <el-table slot="content" :data="previewDeviceList" stripe height="100%" :empty-text="$t('errCode.258')"
        v-loading="loadingPreviewDevice" element-loading-spinner="el-icon-loading" border class="viewDevice"
        :cell-class-name="addClass">
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.device_name')">
          <template slot-scope="scope">
            <span class="redirect" @click="enterDevice(scope.row)" :title="scope.row.devalias || scope.row.sn">{{
              scope.row.devalias || scope.row.sn }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sn" :show-overflow-tooltip="true" :label="$t('device.device_sn')"></el-table-column>
        <el-table-column prop="status" :show-overflow-tooltip="true" :label="$t('device.device_status')">
          <template slot-scope="scope">
            <span v-if="scope.row.status !== undefined" :class="`color-${$filter.deviceStatus[scope.row.status].name}`">{{
              $filter.deviceStatus[scope.row.status].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brand" :show-overflow-tooltip="true" :label="$t('device.device_type')">
          <template slot-scope="scope">{{ scope.row.brand | translateDeviceType }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.device_model')">
          <template slot-scope="scope">
            <span :title="scope.row.devtype || '--'">{{ scope.row.devtype || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.User_belong')">
          <template slot-scope="scope">
            <span :title="scope.row.usr || '--'">{{ scope.row.usr || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('datalogger.administrator')">
          <template slot-scope="scope">
            <span :title="scope.row.dist || '--'">{{ scope.row.dist || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devaddr" :show-overflow-tooltip="true"
          :label="$t('device.device_address')"></el-table-column>
        <el-table-column prop="devcode" :show-overflow-tooltip="true" :label="$t('device.device_code')"></el-table-column>
      </el-table>
    </control-dialog>

    <!--修改数采器-->
    <!-- <datalogger-dialog
      :editing="editingInfo"
      :visible.sync="editingInfo"
      v-if="editingInfo"
      @submitSuc="handleEditSuc"
      @submitFail="handleEditFail"
    ></datalogger-dialog> -->
    <control-dialog :title="$t('datalogger.editDataloggerName')"
      :class="{ 'showDialog': editdataloggerInfo, 'hideDialog': !editdataloggerInfo }" :visible.sync="editdataloggerInfo"
      noFooter>
      <div slot="content">
        <el-form class="grid">
          <el-form-item :label="$t('datalogger.datalogger_name')" prop="alias" size="small">
            <el-input maxlength="64" v-model="dialogAlias" clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button class="btn btn-dark" @click="submit()">{{ $t('device.confirm') }}</button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 修改数采器结果提示(成功) -->
    <!-- v-if="dataloggerEditSucVisible" -->
    <control-dialog :title="$t('datalogger.editResults')" :visible.sync="dataloggerEditSucVisible"
      :class="{ 'showDialog': dataloggerEditSucVisible, 'hideDialog': !dataloggerEditSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.modifySuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerEditSucVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 修改数采器结果提示(失败) -->
    <!-- v-if="dataloggerEditFailVisible" -->
    <control-dialog :title="$t('datalogger.editResults')" :visible.sync="dataloggerEditFailVisible"
      :class="{ 'showDialog': dataloggerEditFailVisible, 'hideDialog': !dataloggerEditFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerEditFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!--解绑数采器-->
    <control-dialog :title="$t('datalogger.unbindDataloggerName')"
      :class="{ 'showDialog': unbindDataloggerVisible, 'hideDialog': !unbindDataloggerVisible }"
      :visible.sync="unbindDataloggerVisible" noFooter>
      <div slot="content">
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.unbindDataloggerExplain') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.resetDataloggerPn }}</span>
        </div>
        <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode"
          :placeholder="$t('datalogger.unbindTitle')"></el-input>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="unbindDataloggerVisible = false;">{{ $t('device.cancel') }}</button>
          <button style="background:#DD6843;" class="btn btn-dark" @click="unbindDataloggerConfirm()">{{
            $t('datalogger.unbind') }}</button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 解绑数采器结果提示(成功) -->
    <!-- v-if="dataloggerEditSucVisible" -->
    <control-dialog :title="$t('datalogger.unbindResults')" :visible.sync="dataloggerUnbindSucVisible"
      :class="{ 'showDialog': dataloggerUnbindSucVisible, 'hideDialog': !dataloggerUnbindSucVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.unbindSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerUnbindSucVisible = false; getDataloggerList()">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 解绑数采器结果提示(失败) -->
    <!-- v-if="dataloggerEditFailVisible" -->
    <control-dialog :title="$t('datalogger.unbindResults')" :visible.sync="dataloggerUnbindFailVisible"
      :class="{ 'showDialog': dataloggerUnbindFailVisible, 'hideDialog': !dataloggerUnbindFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerUnbindFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!--重置数采器-->
    <control-dialog :title="$t('datalogger.resetDataloggerName')"
      :class="{ 'showDialog': resetDataloggerVisible, 'hideDialog': !resetDataloggerVisible }"
      :visible.sync="resetDataloggerVisible" noFooter>
      <div slot="content">
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.resetDataloggerExplain') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.resetDataloggerPn }}</span>
        </div>
        <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode"
          :placeholder="$t('datalogger.resetTitle')"></el-input>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="resetDataloggerVisible = false;">{{ $t('device.cancel') }}</button>
          <button style="background:#DD6843;" class="btn btn-dark" @click="resetDataloggerConfirm()">{{
            $t('datalogger.reset') }}</button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 重置数采器结果提示(成功) -->
    <!-- v-if="dataloggerEditSucVisible" -->
    <control-dialog :title="$t('datalogger.resetResults')" :visible.sync="dataloggerResetSucVisible"
      :class="{ 'showDialog': dataloggerResetSucVisible, 'hideDialog': !dataloggerResetSucVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.resetSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerResetSucVisible = false; getDataloggerList()">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 重置数采器结果提示(失败) -->
    <!-- v-if="dataloggerEditFailVisible" -->
    <control-dialog :title="$t('datalogger.resetResults')" :visible.sync="dataloggerResetFailVisible"
      :class="{ 'showDialog': dataloggerResetFailVisible, 'hideDialog': !dataloggerResetFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerResetFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 重启数采器 -->
    <control-dialog :title="$t('datalogger.rebootDataloggerName')"
      :class="{ 'showDialog': rebootDataloggerVisible, 'hideDialog': !rebootDataloggerVisible }"
      :visible.sync="rebootDataloggerVisible" noFooter>
      <div slot="content">
        <div style="color:#EC9630;font-size:18px;font-weight:700;margin-bottom:50px;">
          <span>{{ $t('datalogger.fixOnRebootDataloggerName') }}</span>
          <span>{{ this.rebootDataloggerData.pn }}</span>
          <span>{{ $t('datalogger.fixOnRebootDataloggerName1') }}</span>
        </div>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;" @click="rebootDataloggerCencel()">{{
            $t('device.cancel') }}</button>
          <!-- <button class="btn btn-dark" @click="rebootDataloggerConfirm()">{{ $t('device.confirm') }}</button> -->
          <button
            class="btn btn-dark"
            :disabled="rebooting"
            @click="rebootDataloggerConfirm()"
          >
            <span v-if="!rebooting">{{ $t('device.confirm') }}</span>
            <span v-else>
              <i class="el-icon-loading"></i> {{ $t('device.confirm') }}
            </span>
          </button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 新增数采器 -->
    <datalogger-dialog :visible.sync="dialogDataloggerVisible" v-if="dialogDataloggerVisible"
      @submitSucAdd="handleCreateSuc" @submitFailAdd="handleCreateFail"></datalogger-dialog>
    <!-- 跳转添加数采器后返回本页的回调 -->
    <!-- 添加结果提示(成功) -->
    <!-- v-if="dataloggerAddSucVisible" -->
    <control-dialog :title="$t('datalogger.addResults')" :visible.sync="dataloggerAddSucVisible"
      :class="{ 'showDialog': dataloggerAddSucVisible, 'hideDialog': !dataloggerAddSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.addedSuccessfully') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <div class="showoperate">
            <!-- 继续添加 -->
            <button type="button" class="btn btn-light" style="margin-right:10px;"
              @click="dataloggerAddSucVisible = false; dialogAddScqClick()">{{ $t('datalogger.continueAdding') }}</button>
            <!-- 完成 -->
            <button type="button" class="btn btn-dark" @click="dataloggerAddSucVisible = false; getDataloggerList();">{{
              $t('datalogger.finish') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 添加结果提示(失败) -->
    <!-- v-if="dataloggerAddFailVisible" -->
    <control-dialog :title="$t('datalogger.addResults')" :visible.sync="dataloggerAddFailVisible"
      :class="{ 'showDialog': dataloggerAddFailVisible, 'hideDialog': !dataloggerAddFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <div class="showoperate">
            <!-- 暂不添加 -->
            <button type="button" class="btn btn-light" style="margin-right:10px;"
              @click="dataloggerAddFailVisible = false;">{{ $t('datalogger.nowNoAdd') }}</button>
            <!-- 重新添加 -->
            <button type="button" class="btn btn-dark" @click="dataloggerAddFailVisible = false; dialogAddScqClick()">{{
              $t('datalogger.reAdd') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 批量查询升级进度 -->
    <control-dialog :class="{ 'showDialog': queryUpgradeDataloggerVisible, 'hideDialog': !queryUpgradeDataloggerVisible }"
      :visible.sync="queryUpgradeDataloggerVisible" :title="$t('device.queryUpgrade')"
      v-if="queryUpgradeDataloggerVisible" width="1125px" noFooter>
      <div slot="content">
        <div class="upgardeControl">
          <el-table style="color:#fff;font-weight:400;" border :empty-text="$t('account.nodata')" :data="selectedplant1"
            :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }">
            <el-table-column prop="pn" :label="$t('device.device_pn')">
            </el-table-column>
            <el-table-column prop="upgradeStatus" :label="$t('device.device_upgradeStatus')">
              <template slot-scope="scope">
                <div v-if="scope.row.upgradeStatus == 5">{{ $t('firmware.upgrade_quit5') }}</div>
                <div v-else-if="scope.row.upgradeStatus == 4">{{ $t('firmware.upgrade_quit6') }}</div>
                <div v-else-if="scope.row.upgradeStatus == 3" style="color:#30EC70;">{{ $t('firmware.upgrade_quit3') }}
                </div>
                <div v-else-if="scope.row.upgradeStatus == 2" style="color:#FF3E3E;">{{ $t('firmware.upgrade_quit7') }}
                </div>
                <div v-else-if="scope.row.upgradeStatus == 1" style="color:#EC9630;">{{ $t('firmware.upgrade_quit8') }}
                </div>
                <div v-else-if="scope.row.upgradeStatus == 0">{{ $t('firmware.upgrading') }}</div>
                <div v-else>{{ $t('errCode.12') }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="progress" :label="$t('device.device_upgradeProgress')">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </control-dialog>
    <!-- 添加数采器 -->
    <control-dialog :class="{ 'showDialog': dialogAddScq, 'hideDialog': !dialogAddScq }" :title="$t('datalogger.addScq')"
      :visible.sync="dialogAddScq" :width="'625px'" noFooter>
      <div class="content_tishi" slot="content">
        <el-form :model="deviceControl" class="mobileoperate grid">
          <el-form-item :required="true" :label="this.$t('device.device_pn')">
            <el-input v-model="deviceControl.pn" class="pnTipSelect">
              <template slot="append">
                <el-popover placement="bottom-end" @show="showHandle" @hide="hideHandle" trigger="hover"
                  popper-class="pnTipBox">
                  <img src="@/assets/img/general/pnMessage.png" />
                  <i style="font-size:20px;" slot="reference" class="iconfont icon-a-mingchengwenhao pnMessage"></i>
                </el-popover>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item :label="this.$t('datalogger.Datalogger_Name')">
            <el-input  maxlength="64" v-model="deviceControl.alias"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="buttonSaveNew">
              <el-button class="button button-solid" @click="AddScq()">{{ $t('recharge.confirm') }}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </control-dialog>
    <!-- 批量添加数采器 -->
    <control-dialog :title="$t('datalogger.batchAddScq')" :visible.sync="batchCollector"
      :class="{ 'showDialog': batchCollector, 'hideDialog': !batchCollector }" width="700px" noFooter>
      <div slot="content" style="display:flex; ">
        <div>
          <span style="color:#F56C6C;">*</span>
          {{ $t('firmware.UploadTitle') }}
        </div>
        <div style="width:520px">
          <el-form class="grid upload-container">
            <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
            <el-form-item label=" ">
              <div class="upload-contents">
                <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploaderCollector.click()">
                  <i class="iconfont icon-shangchuan"></i>
                  <!-- {{$t('firmware.Upload1')}} -->
                </button>
                <div class="upload-tip">{{ `${$t('firmware.Upload1')} (${$t('firmware.limit1')})` }}</div>
                <input type="file" class="upload-input" ref="fileUploaderCollector" accept=".xlsx"
                  @change="uploadCollector($event)" />
              </div>
            </el-form-item>
          </el-form>
          <div style="margin-left:10px">
            <div style="font-size:14px;color:#F56C6C;" class="upload-tip">{{ $t('firmware.limit2') }}</div>
            <img v-if="this.$lang.currentLang == 'zh_CN'" src="@/assets/img/importPnExampleZh.png" alt="">
            <img v-else src="@/assets/img/importPnExampleUs.png" alt="">
          </div>

        </div>

      </div>
    </control-dialog>
  </div>
</template>
<script>
import dataloggerDialog from "@/components/dialognew/dataloggernew";
import controlDialog from "@/components/dialognew";
import updateDialog from "@/components/dialognew/flowIndex";
import signal from "@/components/signalnew";
import exportPlantDialog from "@/components/dialognew/exportPlant";
import clipboard from "@/assets/js/clipboard";
import devicebelong from "./singleBox/devicebelong";
import collectorUpgrade from "./singleBox/collectorUpgrade.vue";
import dataloggerDebug from "./singleBox/dataloggerDebug.vue";
import Vue from 'vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    collectorUpgrade,
    dataloggerDebug,
    dataloggerDialog,
    controlDialog,
    signal,
    exportPlantDialog,
    updateDialog,
    devicebelong
  },
  data () {
    return {
      rebooting: false,
      upgradebButtonStatus:false,
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      loadingupgradeDatalogger:false,
      //时区列表
      zoneList: {
        "-43200": {
          name: "GMT -12:00",
        },
        "-39600": {
          name: "GMT -11:00",
        },
        "-36000": {
          name: "GMT -10:00",
        },
        "-32400": {
          name: "GMT -09:00",
        },
        "-28800": {
          name: "GMT -08:00",
        },
        "-25200": {
          name: "GMT -07:00",
        },
        "-21600": {
          name: "GMT -06:00",
        },
        "-18000": {
          name: "GMT -05:00",
        },
        "-14400": {
          name: "GMT -04:00",
        },
        "-10800": {
          name: "GMT -03:00",
        },
        "-7200": {
          name: "GMT -02:00",
        },
        "-3600": {
          name: "GMT -01:00",
        },
        "0": {
          name: "GMT +00:00",
        },
        "3600": {
          name: "GMT +01:00",
        },
        "7200": {
          name: "GMT +02:00",
        },
        "10800": {
          name: "GMT +03:00",
        },
        "14400": {
          name: "GMT +04:00",
        },
        "18000": {
          name: "GMT +05:00",
        },
        "19800": {
          name: "GMT +05:30",
        },
        "21600": {
          name: "GMT +06:00",
        },
        "25200": {
          name: "GMT +07:00",
        },
        "28800": {
          name: "GMT +08:00",
        },
        "32400": {
          name: "GMT +09:00",
        },
        "36000": {
          name: "GMT +10:00",
        },
        "39600": {
          name: "GMT +11:00",
        },
        "43200": {
          name: "GMT +12:00",
        },
      },
      // 重置数采器
      resetDataloggerPn: "",
      resetDataloggerCode: "",
      // 重启数采器
      rebootDataloggerData: {
        pn: "",
        status: "",
      },
      //数采器名称
      dialogAlias: '',
      //添加数采器
      deviceControl: {
        pn: "",
        alias: "",
      },
      dialogAddScq: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      // dialogDataloggerVisible: false, // 是否显示新增数采器弹窗
      selectedplant: [], //勾选数采器导出
      selectedplant1: [], //勾选数采器升级查询
      activeIf: "1",
      // 原
      search: {
        // 默认正常可在一定程度上优化加载缓慢
        status: 0,
        // pn: "",
        alias: "",
      },
      status: {
        0: {
          num: 0,
          label: this.$t("datalogger.Online"),
          name: "normal"
        },
        1: {
          num: 0,
          label: this.$t("datalogger.Offline"),
          name: "offline"
        }
      },
      // 增加状态下拉新列表
      statusList: [
        {
          num: 2,
          label: this.$t("datalogger.Allstate"),
          name: "total"
        },
        {
          num: 0,
          label: this.$t("datalogger.Normal1"),
          name: "normal"
        },
        {
          num: 1,
          label: this.$t("datalogger.Offline1"),
          name: "offline"
        }
      ],

      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrecharge: "",
      searchrechargeContents: "",
      dataparams: "",
      rechargelist: [],
      loadingDatalogger: false,
      loadingPreviewDevice: false, // 正在加载数采器对应设备表
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      dataloggerList: [],
      debugDataloggerVisible: false,
      queryUpgradeDataloggerVisible: false,//批量升级
      debugingDataloggerId: null,
      upgradeDataloggerVisible: false,
      deletingDataloggerId: null,
      previewDataloggerInfo: null, // 查看的数采器
      previewDeviceList: [], // 查看的数采器对应设备表
      exportPlantParams: [], //导出报表
      datalogger: {
        devaddr: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
      // 搜索弹出
      showSearch: false,
      // 显示上传固件二层弹窗
      dialogAdd: false,
      desc: "",
      remark: "",//备注
      //批量添加数采器
      batchCollector: false,
      // 添加数采器弹框
      dialogDataloggerVisible: false,
      // 添加数采器成功
      dataloggerAddSucVisible: false,
      // 添加数采器失败
      dataloggerAddFailVisible: false,
      // 重启数采器弹框
      rebootDataloggerVisible: false,
      // 重置数采器弹框
      resetDataloggerVisible: false,
      // 重置数采器成功
      dataloggerResetSucVisible: false,
      // 重置数采器失败
      dataloggerResetFailVisible: false,
      // 解绑数采器弹框
      unbindDataloggerVisible: false,
      // 解绑数采器成功
      dataloggerUnbindSucVisible: false,
      // 解绑数采器失败
      dataloggerUnbindFailVisible: false,
      //修改数采器弹窗
      editdataloggerInfo: false,
      // 正在修改的数采器信息
      editingInfo: null,
      // 修改数采器成功
      dataloggerEditSucVisible: false,
      // 修改数采器成功
      dataloggerEditFailVisible: false,
      // 删除数采器成功
      dataloggerDelSucVisible: false,
      // 删除数采器失败
      dataloggerDelFailVisible: false,
      // 升级设备成功
      upgradeDeviceSucVisible: false,
      // 升级设备失败
      upgradeDeviceFailVisible: false,
      // 操作数采器返回提示(错误时)
      dataloggerTipMsg: "",
      // 空页添加数采器回本页通知及值
      isNotice: "",
      isVal: "",
      // 查询该数采器下有无设备
      dataloggeDeviceList: [],
      //批量操作
      // selectedDatalogger: [],
      // 批量升级数采器标记
      upgradeDataloggerBatchSign: false,
      // 升级成功的设备列表
      pnUpOkList: [],
      // 升级失败的设备列表
      pnUpNoList: [],
      // 标记进行批量中的下一个是否进行
      allowNextUpgrade: true,
      // PN码帮助提示
      statusPN: false,
      //更多操作开关
      changeMore: false,
    };
  },
  computed: {
    ...mapGetters({
      getIsShow: "getIsShow",
      getAccountInfo: "getAccountInfo",
      deviceInfo: 'getDeviceInfo',
      dataloggerDetail: 'getDataloggerDetail'
    }),
    // 时区过滤
    filterTimeZone() {
      return (val) => (this.zoneList[val] ? this.zoneList[val].name : "--");
    },
  },
  watch: {
    // 响应更新电站列表事件
    "$store.state.event.updateDataloggerList" (val) {
      if (val) {
        this.getDataloggerList();
        this.$store.state.event.updateDataloggerList = false;
      }
    },
    upgradeDataloggerVisible (val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
        this.upgradebButtonStatus = false;
      }
    },
    queryUpgradeDataloggerVisible (val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    },
  },
  created () {
    this.$store.commit('saveIsShow', 1);
    this.$store.commit('saveDataloggerDetail', 1);
    this.getDataloggerList();
    // 其它页添删数采器回数采器管理页通知(空白页等)
    if (this.$route.query.tool) {
      this.isNotice = this.$route.query.tool.notice;
      this.isVal = this.$route.query.tool.noticeVal;
    }
    if (this.isNotice == 'Suc') {
      // console.log('数采器管理页=>添加成功回调');
      this.handleCreateSuc();
      window.location.href = this.delurlquery(window.location.href, "tool");
    } else if (this.isNotice == 'Fail') {
      // console.log('数采器管理页=>添加失败回调');
      this.handleCreateFail(this.isVal);
      window.location.href = this.delurlquery(window.location.href, "tool");
    } else if (this.isNotice == 'delSuc') {
      // console.log('数采器管理页=>删除成功回调');
      this.handleDelSuc();
      window.location.href = this.delurlquery(window.location.href, "tool");
    }
  },
  methods: {
    //更多操作
    changeMoreValue (changeMore) {
      this.changeMore = changeMore;
    },
    // 解绑数采器弹窗
    unbindDatalogger (info) {
      this.unbindDataloggerVisible = true
      this.resetDataloggerPn = info
      this.resetDataloggerCode = ""
    },
    // 确定解绑数采器
    unbindDataloggerConfirm () {
      if (this.resetDataloggerCode === "YES") {
        this.unbindDataloggerVisible = false
        let param = {
          pn: this.resetDataloggerPn,
          // level:1,
        }
        this.$request.get("vendorUnbindingCollector", param).then((res) => {
          if (res.err == 0) {
            this.dataloggerUnbindSucVisible = true
          } else {
            this.dataloggerUnbindFailVisible = true
            this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          }
        })
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`))
      }
    },
    // 重置数采器弹窗
    resetDatalogger (info) {
      this.resetDataloggerVisible = true
      this.resetDataloggerPn = info
      this.resetDataloggerCode = ""
    },
    // 确定重置数采器
    resetDataloggerConfirm () {
      if (this.resetDataloggerCode === "YES") {
        this.resetDataloggerVisible = false
        let param = {
          pn: this.resetDataloggerPn,
          level: 3,
        }
        this.$request.get("delDevicesResetPlant", param).then((res) => {
          if (res.err == 0) {
            this.dataloggerResetSucVisible = true
          } else {
            this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
            this.dataloggerResetFailVisible = true
          }
        })
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`))
      }
    },
    // PN码帮助提示
    showHandle () {
      this.statusPN = true;
    },
    hideHandle () {
      this.statusPN = false;
    },
    //开启数采器详情页
    clickClosepage (info) {
      this.$store.commit('saveIsShow', 2);
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: info.status,
        descx: info.descx,
        load: info.load,
        edate: info.edate,
        // status: 4,
        // 增
        brand: info.brand,
        devalias: info.alias,
        // 增
        collalias: info.calias,
        signal: info.signal,
        // focus: info.focus,
        // 增
        // devtype: info.devtype,
        usr: info.usr?info.usr:'',
        // 增
        Firmware_Version: info.fireware?info.fireware:'',
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
      });
    },
    // 开启数采器弹窗
    dialogAddScqClick () {
      if(this.disPermissionsLogo&&!this.btnList.includes('add_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.dialogAddScq = true
      this.deviceControl.pn = ''
      this.deviceControl.alias = ''
    },
    //添加数采器
    AddScq () {
      let params = {
        pn: this.deviceControl.pn,
        alias: this.deviceControl.alias,
      }
      this.$request.get("distAddCollector", params).then((res) => {
        if (res.err == 0) {
          this.dataloggerAddSucVisible = true
          this.dataloggerTipMsg = this.$t("datalogger.deleteSuc");
          this.dialogAddScq = false
          this.activeIf = 0
        } else {
          this.dataloggerAddFailVisible = true
          this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          this.dialogAddScq = false
        }
      })
    },
    //批量添加数采器点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadCollector (event) {
      // this.$refs.upload.clearFiles()
      let file = event.target.files[0];
      // if (file.size > 8 * 1024 * 1024) {
      //   this.$message.error(this.$t("createPlant.fileExceed"));
      //   return;
      // }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "xlsx") {
        this.$message.error(this.$t("firmware.limit1"));
        return;
      }
      this.$request.uploadCollector(file, { action: 'addCollectors', i18n: this.$lang.currentLang }).then(res => {
        if (res.err === 0) {
          if (res.dat) {
            this.$message.success(this.$t("createPlant.uploadSuccess"));
            let params = {
              action: "downLoadFile",
              id: res.dat,
              i18n: this.$lang.currentLang,
            }
            if (res.err) {
              this.$message.error(this.$t(`errCode.${res.err}`));
              return;
            } else {
              window.location.href = this.$request.http_download_url_new(params)
              // this.closeDialog();
              this.batchCollector = false
              this.activeIf = 0
              this.getDataloggerList()
              setTimeout(() => { this.$message.success(this.$t("report.download")) }, 2000)
            }
          }else{
            this.batchCollector = false
            this.$message.success(this.$t("firmware.limit3"));
          }
          // this.$message.success(this.$t("report.download"));
          // this.$message.success(this.$t("createPlant.uploadSuccess"));
          // this.getData();
          // 关闭二次弹窗
        } else if (res.err === 6) {
          this.$message.error(this.$t("firmware.limit1"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        //清除上次所传文件
        event.target.value = ''
      });
    },
    clickBatchCollector () {
      if(this.disPermissionsLogo&&!this.btnList.includes('add_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.file = null
      this.batchCollector = true
    },
    //模糊查询搜索所有状态
    queryGetDataloggerList () {
      if (this.search.status) {
        this.search.status = ''
      }
      this.getDataloggerList()
    },
    //选择数采器状态
    activeClass (value, key) {
      this.activeIf = key
      if (value.name == "normal") {
        this.search.status = '0'
      } else if (value.name == "offline") {
        this.search.status = '1'
      } else {
        this.search.status = ''
      }
      this.getDataloggerList(true)
    },
    //表格设备名称修改超出隐藏省略号颜色
    addClass ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "deviceName"
      }
    },
    addClass1 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 5) {
        return "deviceName"
      }
    },
    // 辅助传参=删url指定query
    delurlquery (url, key) {
      key = this.escapereg(key);
      var reg = new RegExp("((\\?)(" + key + "=[^&]*&)+(?!" + key + "=))|(((\\?|&)" + key + "=[^&]*)+$)|(&" + key + "=[^&]*)", "g");
      return url.replace(reg, "\x241")
    },
    // 辅助传参=拼正则表达式字符串时消除原字符串中特殊字符干扰
    escapereg (str) {
      return str.replace(new RegExp("([.*+?^=!:\x24{}()|[\\]/\\\\])", "g"), "\\\x241");
    },
    progressText (progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    //勾选多项
    changeFun (val) {
      this.selectedplant = val; // 返回的是选中的列的数组集合
      this.selectedplant1 = val; // 返回的是选中的列的数组集合
    },
    // 导出报表
    exportPlant (exportPlantParams) {
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    //循环遍历调用接口
    queryUpgradeDatalogger1 () {
      this.selectedplant1.forEach((item, index) => {
        let params = {
          pn: item.pn,
          // devcode:item.devcode,
          // devaddr:item.devaddr,
          // sn:item.sn
        }
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeStatus", params)
          .then((res) => {
            // this.selectedplant1[index].progress=res.data.progress/10+"%"
            // this.selectedplant1[index].upgradeStatus=res.data.status
            Vue.set(this.selectedplant1[index], 'progress', res.data.progress / 10 + "%");
            Vue.set(this.selectedplant1[index], 'upgradeStatus', res.data.status);
          }).catch()
      })
    },
    // 查询数采器列表
    getDataloggerList (reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        ...this.search,
        devtype: 2304,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };
      this.loadingDatalogger = true;
      this.$request.get("webQueryCollectorsEs", param).then(res => {
        if (res.err === 0) {
          this.dataloggerList = res.dat.collector;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.dataloggerList = [];
          this.pagination.total = 0;
        }
        this.loadingDatalogger = false;
      });
    },
    // 查看数采器对应设备
    previewDatalogger (info) {
      this.previewDataloggerInfo = {
        pn: info.pn,
        alias: info.alias || info.pn
      };
      let param = {
        pn: info.pn,
        devtype: 2304,
        page: 1,
        pageSize: 50
      };
      this.loadingPreviewDevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code === 0) {
          this.previewDeviceList = this.Fnreturndev(res);
        } else {
          this.previewDeviceList = [];
        }
        this.loadingPreviewDevice = false;
      });
    },
    // 点击进入设备(此处跳转我的设备)
    // enterDevice(info) {
    //   // this.$store.commit("saveDeviceInfo", {
    //   //   pn: info.pn,
    //   //   sn: info.sn,
    //   //   devcode: info.devcode,
    //   //   devaddr: info.devaddr
    //   // });
    //   this.$router.push({
    //     path: '/adminNew/home',
    //     query: {
    // 	  	'tool' : {
    // 	  		// 'curDeviceMark': 'Suc',
    //         'curDeviceInfo': info,
    // 	  	}
    //     }
    //   });
    // },
    // 点击进入设备(在本页显隐)
    enterDevice (info) {
      // console.log("show=>singleBox(device)");
      //查看设备详情信息
      // this.$store.commit("saveDeviceInfo", {
      //   pn: info.pn, //
      //   sn: info.sn, //
      //   devaddr: info.devaddr, //
      //   devcode: info.devcode, //
      //   status: info.status, //
      //   devalias: info.devalias, //
      //   pid: info.pid, //
      //   focus: info.focus, //
      //   usr: info.usr, //
      //   uid: info.uid, //
      // });
      // // 通知显示设备信息页(隐藏table)
      // this.$emit('noticeSingleBox', true);
      //跳转用户界面
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                pid: info.pid,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 添加数采器成功回调
    handleCreateSuc (pn) {
      // console.log('数采器管理页=>添加成功回调(带pn)', pn);
      // this.$message.success(this.$t("datalogger.addSuc"));
      // this.dataloggerAddFailMsg = val;
      // this.dataloggerAddSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      // 通知侧栏项目列表更新
      this.$store.state.event.updateProjectList = true;

      // 查询该数采器下有无设备
      // (普通用户做以下处理,经销商/管理员不考虑)
      // this.getDataloggerDevice(pn);

      this.dataloggerAddSucVisible = true;
      this.getDataloggerList();
    },
    // 添加数采器失败回调
    handleCreateFail (val) {
      this.dataloggerTipMsg = val;
      this.dataloggerAddFailVisible = true;
    },
    // 查看数采器对应设备
    // (普通用户做以下处理,经销商/管理员不考虑)
    getDataloggerDevice (pn) {
      let param = {
        pn: pn,
        devtype: 2304,
        page: 1,
        pageSize: 50
      };
      // this.loadingPreviewDevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        // console.log('数采器管理页=>查询该数采器下设备情况');
        if (res.code == 0 && Array.isArray(res.data && res.data.items) && res.data.items.length > 0) {
          // console.log('数采器管理页=>查询成功');
          this.dataloggeDeviceList = this.Fnreturndev(res);
          let deviceInfo = this.dataloggeDeviceList[0];
          if (this.dataloggeDeviceList.length > 0) {
            // console.log('数采器管理页=>该数采器下有设备');
            // 保存设备信息
            this.$store.commit("saveDeviceInfo", {
              pn: deviceInfo.pn,
              sn: deviceInfo.sn,
              deviceSn: deviceInfo.deviceSn || deviceInfo.sn,
              devaddr: deviceInfo.devaddr,
              devcode: deviceInfo.devcode,
              status: deviceInfo.status,
              devalias: deviceInfo.devalias,
              profitToday: deviceInfo.profitToday,
              profitTotal: deviceInfo.profitTotal,
              sellProfitToday: deviceInfo.sellProfitToday,
              sellProfitTotal: deviceInfo.sellProfitTotal,
              buyProfitToday: deviceInfo.buyProfitToday,
              buyProfitTotal: deviceInfo.buyProfitTotal,
              // pid: deviceInfo.pid,
              focus: deviceInfo.focus
            });
            // 跳转我的设备
            this.$router.push({
              path: '/adminNew/home',
              query: {
                'tool': {
                  'notice': 'Suc'
                }
              }
            });
          } else {
            // console.log('数采器管理页=>该数采器下无设备');
            this.dataloggerAddSucVisible = true;
            this.getDataloggerList();
          }
        } else {
          // console.log('数采器管理页=>查询失败');
          this.dataloggeDeviceList = [];
          this.dataloggerAddSucVisible = true;
          this.getDataloggerList();
        }
        // this.loadingPreviewDevice = false;
      });
    },
    // 确定重启数采器
    rebootDataloggerConfirm () {
      if (this.rebooting) return;
      this.rebooting = true;
      let param = {
        pn: this.rebootDataloggerData.pn
      }
      this.$request.get("restartCollector", param).then((res) => {
        this.rebooting = false;
        this.rebootDataloggerVisible = false
        if (res.err == 0) {
          if (this.rebootDataloggerData.status == 1) {
            this.$message.error(this.$t(`errCode.263`));
          } else {
            this.$message.success(this.$t("datalogger.rebootDataloggerSuc"));
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      }).catch(() => {
        this.rebooting = false;
      });
    },
    // 取消重启数采器
    rebootDataloggerCencel (info) {
      this.rebootDataloggerVisible = false
    },
    // 重启数采器弹窗
    rebootDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('restart_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.rebootDataloggerData.pn = info.pn
      this.rebootDataloggerData.status = info.status
      this.rebootDataloggerVisible = true
    },
    // 修改数采器弹窗
    editDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('edit_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.editdataloggerInfo = true
      this.dialogAlias = info.alias
      let param = {
        pn: info.pn
      }
      this.$request.get("queryCollectorinfoEs", param).then(res => {
        if (res.err === 0) {
          this.editingInfo = {
            pn: info.pn,
            pid: info.pid,
            pname: info.pname,
            ...res.dat
          };
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 修改数采器提交
    submit () {
      let param = {
        pid: this.editingInfo.pid,
        pn: this.editingInfo.pn,
        alias: this.dialogAlias
      }
      this.$request.get("editCollectorEs", param).then((res) => {
        if (res.err == 0) {
          this.editdataloggerInfo = false
          this.handleEditSuc()
        } else {
          this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          this.dataloggerEditFailVisible = true;
          this.editdataloggerInfo = false
        }
      })
    },
    // 修改数采器成功回调
    handleEditSuc () {
      // this.$message.success(this.$t("datalogger.modifySuc"));
      this.dataloggerEditSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      this.getDataloggerList();
    },
    // 修改采器失败回调
    handleEditFail (val) {
      this.dataloggerTipMsg = val
      this.dataloggerEditFailVisible = true;
    },
    // 删除数采器
    deleteDatalogger (pn) {
      if(this.disPermissionsLogo&&!this.btnList.includes('delete_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.resetDataloggerCode = ""
      this.deletingDataloggerId = pn;
    },
    // 确定删除数采器
    submitDeleteDatalogger () {
      if (this.resetDataloggerCode === "YES") {
        this.$request
          .get("delCollectorFromPlant", { pn: this.deletingDataloggerId })
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("datalogger.deleteSuc"));
              this.dataloggerTipMsg = this.$t("datalogger.deleteSuc");
              this.dataloggerDelSucVisible = true;
              this.deletingDataloggerId = null;
              // 通知数采器列表更新
              this.$store.state.event.updateDataloggerList = true;
              this.getDataloggerList();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
              this.dataloggerDelFailVisible = true;
            }
          });
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`))
      }
    },
    // 删除数采器成功回调
    handleDelSuc () {
      this.dataloggerDelSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      this.getDataloggerList();
    },
    // 调试数采器
    debugDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('debug_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.datalogger = info
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: info.status,
        descx: info.descx,
        load: info.load,
        edate: info.edate,
        brand: info.brand,
        devalias: info.alias,
        collalias: info.calias,
        signal: info.signal,
        usr: info.usr,
        Firmware_Version: info.fireware,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
      });
      this.$store.commit('saveIsShow', 4);
    },
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDatalogger () {
      if (this.datalogger.devaddr == null) {
        this.$message.error(this.$t("datalogger.devaddrfail"));
      } else if (this.datalogger.status == "1") {
        this.$message.error(this.$t("datalogger.Debugfail"));
      } else {
        this.debugReturn = this.$t("datalogger.instruction_response");
        let param = {
          pn: this.datalogger.pn,
          devaddr: this.datalogger.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 升级中的上传固件
    uploadFirmwareAdd(){
      if(this.disPermissionsLogo&&!this.btnList.includes('upload_firmware')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.dialogAdd = true;
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
        this.desc = null;
        this.remark = null;
      });
    },
    voltageArr (item) {
      this.rechargelist.forEach(element => {
        if (element.id == item) {
          this.searchrechargeContents = element
        }
      });
    },
    // 新增：数采器固件升级(多个)==========
    upgradeDataloggerBatch (info) {
      // console.log("[upgradeDataloggerBatch]");
      // console.log("[upgradeDataloggerBatch-info]", info);

      // 清空升级成功与失败列表
      this.pnUpOkList = [];
      this.pnUpNoList = [];
      // 标记进行批量中的下一个是否进行
      this.allowNextUpgrade = true;

      // 至少选中1条
      if (!this.selectedplant) { return }

      // 固件列表
      this.queryFirmware();
      // 数采器数据
      // this.dataparams = info;
      // 数采器批量升级标记
      this.upgradeDataloggerBatchSign = true;
      // 弹窗
      this.upgradeDataloggerVisible = true;
      // 进度
      this.progerssComplete = false;
    },
    queryUpgradeDatalogger (info) {
      this.queryUpgradeDatalogger1()
      // 清空升级成功与失败列表
      this.pnUpOkList = [];
      this.pnUpNoList = [];
      // 标记进行批量中的下一个是否进行
      this.allowNextUpgrade = true;
      // 至少选中1条
      if (!this.selectedplant1) { return }
      // 固件列表
      this.queryFirmware();
      // 数采器批量升级标记
      this.upgradeDataloggerBatchSign = true;
      // 弹窗
      this.queryUpgradeDataloggerVisible = true;
      // 进度
      this.progerssComplete = false;
    },
    // 新增：确认固件批量升级(多)
    submitUpgradeDataloggerBatch () {
      // 当前选中 (this.selectedplant) 循环请求
      // this.selectedplant.forEach((item)=>{
      //   this.submitUpgradeDataloggerBatchFun();
      // });

      // 升级前的情况处理..........
      // [1]已超过最大批量数
      if (this.selectedplant.length > 100) {
        // 注意国际化
        // this.$t("datalogger.updatefail")
        this.$message.error("已超出最大批量数100");
        return;
      }
      // [2]请先选择要升级的固件
      if (!this.searchrecharge) {
        this.$message.error(this.$t("datalogger.file_fist"));
        return;
      }
      // [3]升级失败，采集器可能离线，或者检查是否与采集器通讯正常
      let statusPass = this.selectedplant.some((item) => {
        return item.status == "1";
      });
      if (statusPass) {
        this.$message.error(this.$t("datalogger.updatefail"));
        return;
      }

      // 升级提交..........
      // this.selectedplant.forEach((item) => {
      //   console.log("[upgradePn-item]", item);
      //   this.submitUpgradeDataloggerBatchFun(item);
      // });

      // 数采器批量升级初次调用
      this.submitUpgradeDataloggerBatchFun(this.selectedplant, 0);
    },
    // 新增：确认固件批量升级(多)
    submitUpgradeDataloggerBatchFun (arr, index) {
      // console.log("[submitUpgradeDataloggerBatchFun]");
      // console.log("[submitUpgradeDataloggerBatchFun=index]", index);
      // console.log("[submitUpgradeDataloggerBatchFun=allowNextUpgrade]", this.allowNextUpgrade);
      // return;

      // 升级操作
      if (arr.length > index && this.allowNextUpgrade) {
        // 标记进行批量中的下一个是否进行
        this.allowNextUpgrade = false;

        this.progress = 0;
        // if (!this.searchrecharge) {
        //   this.$message.error(this.$t("datalogger.file_fist"));
        // } else if (this.dataparams.status == "1") {
        //   this.$message.error(this.$t("datalogger.updatefail"));
        // } else {
        // ==========
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          // pn: this.dataparams.pn,
          pn: arr[index].pn,
          firmwareId: this.searchrecharge
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/collector/firmwareUpgradeCollector", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("datalogger.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              // this.queryProgress();
              this.queryProgress(arr[index], ++index);
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
          }
        });
        // ==========
        // }

      }
    },
    // 数采器固件升级(单个)==========
    upgradeDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('upgrade_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.queryFirmware();
      this.upgradeDataloggerVisible = true;
      // 增：数采器批量升级标记
      this.upgradeDataloggerBatchSign = false;
      this.dataparams = info;
      this.progerssComplete = false;
    },
    // 查询固件列表
    queryFirmware () {
      this.searchrecharge = null;
      this.rechargelist = [];
      this.loadingupgradeDatalogger = true;
      const allItems = [];
      const pagesize = 100;
      let page = 0;
      (async () => {
        while (true) {
          let res = await this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { page, pagesize });
          if (res.code == 0 && Array.isArray(res.data.items)) {
            res.data.items.forEach(item => {
              allItems.push({
                id: item.id,
                firmware: item.firmware,
                size: item.size
              });
            });
            if (res.data.items.length < pagesize) break;
            page++;
          } else {
            break;
          }
        }
        this.rechargelist = allItems;
        this.loadingupgradeDatalogger = false;
      })();
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("datalogger.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("datalogger.error1"));
        return;
      }
      this.$request.uploadfileAxios(file, this.desc, this.remark).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("datalogger.uploadSuccess"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("datalogger.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        this.queryFirmware();
      });
    },
    // 确认固件升级
    submitUpgradeDatalogger () {
      this.progress = 0;
      if (!this.searchrecharge) {
        this.$message.error(this.$t("datalogger.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("datalogger.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          firmwareId: this.searchrecharge
        };
        this.upgradebButtonStatus = true;
        this.$request.postUPG("/upg/api/auth/web/shineDess/collector/firmwareUpgradeCollector", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("datalogger.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              // this.upgradeDeviceSucVisible = true;
              this.queryProgress();
              // this.upgradeDataloggerVisible = false;
              // this.dialogAdd = false;
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              this.upgradebButtonStatus = false;
              // this.dataloggerTipMsg = this.$t("device.System_Failed");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              this.upgradebButtonStatus = false;
              // this.dataloggerTipMsg = this.$t("device.Device_Offline");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              this.upgradebButtonStatus = false;
              // this.dataloggerTipMsg = this.$t("device.In_Upgrading");
              // this.upgradeDeviceFailVisible = true;
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            this.upgradebButtonStatus = false;
            // this.dataloggerTipMsg = this.$t(`errCode.${res.code}`);
            // this.upgradeDeviceFailVisible = true;
          }
        });
      }
    },
    // 查询升级进度(增加批量标志)
    queryProgress (info, curIndex) {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        // 查数采器升级进度所需参数
        pn: info ? info.pn : this.dataparams.pn,
        // devaddr: this.dataparams.devaddr,
        // devcode: this.dataparams.devcode,
        // sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));

                  // [暂时不关闭升级弹窗]
                  // setTimeout(() => {
                  //   this.upgradeDataloggerVisible = false;
                  //   // 增：数采器批量升级标记
                  //   this.upgradeDataloggerBatchSign = false;
                  // }, 3000);

                  // ........................................
                  // 显示升级成功的数采器Pn 
                  let hasOkPn0 = this.pnUpOkList.some((item) => {
                    item == params.pn;
                  });
                  if (!hasOkPn0) {
                    this.pnUpOkList.push(params.pn);
                  }
                  // let hasNoPn0 = this.pnUpNoList.some((item)=>{
                  //   item == params.pn;
                  // });
                  // if(!hasNoPn0){
                  //   this.pnUpNoList.push(params.pn);
                  // }

                  // 根据选中条数判断
                  if (this.selectedplant.length > curIndex) {
                    // 标记进行批量中的下一个是否进行
                    this.allowNextUpgrade = true;
                    this.submitUpgradeDataloggerBatchFun(this.selectedplant, curIndex);
                  } else {
                    // 升级操作完毕
                    this.progressUp = false;
                    this.progerssComplete = true;
                  }
                  // ........................................
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;

                // [暂时不关闭升级弹窗]
                // this.upgradeDataloggerVisible = false;
                // // 增：数采器批量升级标记
                // this.upgradeDataloggerBatchSign = false;

                // ........................................
                // 显示升级失败的数采器Pn 
                let hasNoPn1 = this.pnUpNoList.some((item) => {
                  item == params.pn;
                });
                if (!hasNoPn1) {
                  this.pnUpNoList.push(params.pn);
                }

                // 根据选中条数判断
                if (this.selectedplant.length > curIndex) {
                  // 标记进行批量中的下一个是否进行
                  this.allowNextUpgrade = true;
                  this.submitUpgradeDataloggerBatchFun(this.selectedplant, curIndex);
                } else {
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                }
                // ........................................

                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;

                // [暂时不关闭升级弹窗]
                // this.upgradeDataloggerVisible = false;
                // // 增：数采器批量升级标记
                // this.upgradeDataloggerBatchSign = false;

                // ........................................
                // console.log("[quit2=this.pnUpNoList]", [...this.pnUpNoList]);
                // 显示升级失败的数采器Pn 
                let hasNoPn2 = this.pnUpNoList.some((item) => {
                  item == params.pn;
                });
                if (!hasNoPn2) {
                  this.pnUpNoList.push(params.pn);
                }

                // 根据选中条数判断
                if (this.selectedplant.length > curIndex) {
                  // 标记进行批量中的下一个是否进行
                  this.allowNextUpgrade = true;
                  this.submitUpgradeDataloggerBatchFun(this.selectedplant, curIndex);
                } else {
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                }
                // ........................................

                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;

                // [暂时不关闭升级弹窗]
                // this.upgradeDataloggerVisible = false;
                // // 增：数采器批量升级标记
                // this.upgradeDataloggerBatchSign = false;

                // ........................................
                // 显示升级成功的数采器Pn 
                let hasOkPn3 = this.pnUpOkList.some((item) => {
                  item == params.pn;
                });
                if (!hasOkPn3) {
                  this.pnUpOkList.push(params.pn);
                }

                // 根据选中条数判断
                if (this.selectedplant.length > curIndex) {
                  // 标记进行批量中的下一个是否进行
                  this.allowNextUpgrade = true;
                  this.submitUpgradeDataloggerBatchFun(this.selectedplant, curIndex);
                } else {
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                }
                // ........................................

                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;

                // [暂时不关闭升级弹窗]
                // this.upgradeDataloggerVisible = false;
                // // 增：数采器批量升级标记
                // this.upgradeDataloggerBatchSign = false;

                // ........................................
                // 显示升级失败的数采器Pn 
                let hasNoPn4 = this.pnUpNoList.some((item) => {
                  item == params.pn;
                });
                if (!hasNoPn4) {
                  this.pnUpNoList.push(params.pn);
                }

                // 根据选中条数判断
                if (this.selectedplant.length > curIndex) {
                  // 标记进行批量中的下一个是否进行
                  this.allowNextUpgrade = true;
                  this.submitUpgradeDataloggerBatchFun(this.selectedplant, curIndex);
                } else {
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                }
                // ........................................

                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;

                // [暂时不关闭升级弹窗]
                // this.upgradeDataloggerVisible = false;
                // // 增：数采器批量升级标记
                // this.upgradeDataloggerBatchSign = false;

                // ........................................
                // 显示升级失败的数采器Pn 
                let hasNoPn5 = this.pnUpNoList.some((item) => {
                  item == params.pn;
                });
                if (!hasNoPn5) {
                  this.pnUpNoList.push(params.pn);
                }

                // 根据选中条数判断
                if (this.selectedplant.length > curIndex) {
                  // 标记进行批量中的下一个是否进行
                  this.allowNextUpgrade = true;
                  this.submitUpgradeDataloggerBatchFun(this.selectedplant, curIndex);
                } else {
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                }
                // ........................................

                return;
              }
            } else {
              // console.log("[errCode]");
              // ........................................
              // 显示升级失败的数采器Pn 
              // let hasNoPnErr = this.pnUpNoList.some((item)=>{
              //   item == params.pn;
              // });
              // if(!hasNoPnErr){
              //   this.pnUpNoList.push(params.pn);
              // }

              // 根据选中条数判断
              if (this.selectedplant.length > curIndex) {
                // 标记进行批量中的下一个是否进行
                this.allowNextUpgrade = true;
              } else {
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
              }
              // ........................................

              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
              this.upgradebButtonStatus = false;
            }
          });
      }, 2000);
    },
    //取消升级
    upgradeCancel () {
      this.$request.putUPG("/upg/api/auth/web/shineDess/collector/collectorCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.progressUp = false
            clearInterval(this.interval);
            this.upgradebButtonStatus = false;
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDataloggerVisible = false;
            // 增：数采器批量升级标记
            this.upgradeDataloggerBatchSign = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.pn = '';
      // this.search.status = '';
      this.search.alias = '';
      this.getDataloggerList();
    },
    // closeSearch2(){
    //   console.log("zhiling");
    // },
    // closeSearch2() {
    //   this.search.pn = '';
    //   this.search.status = '';
    //   if (this.showSearch) {
    //     this.getDataloggerList();
    //   }
    //   this.showSearch = false;
    // },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    },
    // 关闭批量操作弹条
    closeBatch () {
      this.$refs.multiplePnTable.clearSelection();
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  .mobileoperate {

    // PN码帮助提示
    .pnMessage {
      color: @primaryTextColor;
      cursor: pointer;
    }

    .pnTipSelect {
      border: 1px solid #A3A9B5;
      border-radius: 4px;

      /deep/.el-input-group__append,
      /deep/.el-input-group__prepend {
        padding: 0 10px;
        background: #2b3842;
        border: none;
      }

      /deep/.el-input__inner {
        border: none;
      }
    }
  }

  .mobileoperate /deep/.el-form-item__label {
    color: #fff;
  }

  .buttonSaveNew {
    text-align: right;

    // margin-top: 10px;
    button {
      box-sizing: content-box;
      padding: 8px 11px;
      height: 38px;
      line-height: 38px;
      padding: 0 22px;
      font-size: 14px;
      margin-left: 10px;
    }
  }

  .redirect {
    color: @primaryTextColor;
  }
  .elbtn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    line-height:normal
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .statusName {
        padding: 0 16px;
        color: #ADB9C0;
        font-size: 12px;
        line-height: 48px;
        font-weight: 700;
      }

      .statusList {
        cursor: pointer;
        padding: 0 16px;
        color: #70818C;
        font-size: 14px;
        height: 48px;
        line-height: 48px;
      }

      .active {
        color: #00FEBB;
        border-bottom: 2px solid #00FEBB;
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        // left: 0;
        right: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          // line-height: 48px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .search-alert1 {
        position: absolute;
        top: 0;
        left: 0;
        // right: 284px;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          // line-height: 48px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .batch-alert {
        height: 48px;
        line-height: 48px;
      }

      // 添加数采器
      .button-addscq {
        // width: 114px;
        height: 48px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        cursor: pointer;

        span {
          font-size: 14px;
        }

        i {
          margin-left: 10px;
        }
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      .operation1 i {
        color: @primaryColorTransparency30;
      }

      // 表格右侧边线
      // /deep/.el-table--border::after, 
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  // 设备调试返回值
  .debug-return {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 6px 8px;
    background: rgba(43, 56, 66, 1);

    /deep/.el-textarea__inner {
      border: none;
      background: rgba(43, 56, 66, 1);
    }

    .return-tool {
      border-top: 1px dashed rgba(204, 206, 221, 0.5);
      text-align: right;
      padding: 6px 10px 0px;
      margin-top: 5px;

      .btn:hover {
        color: @primaryTextColor;

        .ico-clear {
          background: url(../../../assets/img/general/Icon_Debug_Delete_Dark.png);
        }

        .ico-copy {
          background: url(../../../assets/img/general/Icon_Debug_Copy_Dark.png);
        }
      }

      .btn {
        padding: 0px;
        color: rgba(235, 235, 235, 1);
        font-size: 12px;
        cursor: pointer;
      }

      .ico-clear {
        background: url(../../../assets/img/general/Icon_Debug_Delete.png);
      }

      .ico-copy {
        background: url(../../../assets/img/general/Icon_Debug_Copy.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
      }
    }
  }

  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 数采器下设备列表
  .datalogger-device {

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }

    /deep/.el-table__row.el-table__row--striped td {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }

    /deep/.el-table__body-wrapper,
    .el-table__footer-wrapper,
    /deep/.el-table__header-wrapper {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }
  }

  // 数采器对应设备
  .viewDevice {
    // border: none;
    border-top: 1px solid #A3A9B5;

    /deep/.el-table th,
    /deep/.el-table tr {
      border: 1px solid #A3A9B5;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      border-color: #A3A9B5;
    }

    /deep/.el-table__body,
    /deep/.el-table__footer,
    /deep/.el-table__header {
      border-left: none;
      border-right: none;
    }

    /deep/.el-table__empty-block {
      background: #222d35;
    }

    // .el-table__body, 
    // .el-table__footer, 
    // .el-table__header {
    //   // table-layout: auto;
    //   // border-left: 1px solid #A3A9B5;
    //   // border-right: 1px solid #A3A9B5;
    // }
  }

  // 固件升级状态窗
  .upgradeNew {

    .processstatue,
    .processstatueEquipment {
      font-size: 16px;
      color: #16D09A;
    }

    /deep/.el-progress__text {
      color: #ffffff;
    }

    .progerssComplete,
    .progerssCompleteEquipment {
      background: transparent;
    }

    .progerssComplete {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: 0px;
      align-items: flex-start;

      .progressName {
        margin-left: 0px;
      }
    }
    // 遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // 花形
    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    // 环形
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
    /deep/.el-icon-loading {
      font-size: 28px;
    }
  }

  // 批量操作弹条
  .batch-alert {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    z-index: 1;
    background: rgba(255, 231, 107, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .batch-total {
      padding-left: 16px;
      font-size: 14px;
    }

    .batch-right {
      display: flex;
      justify-content: flex-end;
    }

    .batch-hide {
      height: 48px;
      line-height: 48px;
      padding: 0px 16px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 1);
      }
    }

    .batch-operate {
      display: flex;
      justify-content: flex-end;

      .btn {
        color: rgba(34, 45, 53, 1);
        font-size: 14px;
        cursor: pointer;
        // display: inline-block;
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        border-radius: 0px;
        display: flex;
        align-items: center;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .ico-copy {
        background: url(../../../assets/img/general/Icon_Batch_Copy.png);
      }

      .ico-export {
        background: url(../../../assets/img/general/Icon_Batch_Export.png);
      }

      .ico-clear {
        background: url(../../../assets/img/general/Icon_Batch_Delete.png);
      }

      .ico-upgrade {
        background: url(../../../assets/img/general/Icon_Batch_Upgrade.png);
      }

      .ico-more {
        background: url(../../../assets/img/general/Icon_Batch_More.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 8px;
      }

      // 批量更多下拉 (不可scoped)(.dropdown-more)
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}

//批量设备升级样式
.upgardeControl {

  /deep/.el-table th>.cell {
    font-weight: 400;
  }

  /deep/.el-table tr {
    background-color: #222D35;
  }

  /deep/.el-table th.is-leaf {
    border-right: 1px solid rgba(102, 102, 102, 0.5);
    border-bottom: 1px solid rgba(102, 102, 102, 0.5);
  }

  /deep/.el-table td {
    border-right: 1px solid rgba(102, 102, 102, 0.5);
    border-bottom: 1px solid rgba(102, 102, 102, 0.5);
  }

  /deep/.el-table__body tr.hover-row td {
    background-color: rgba(48, 208, 150, 0.15);
  }
}
</style>
<style lang="less">
// #PN码帮助提示#
.pnTipBox.el-popover {
  padding: 10px;
  border: none;
  background: #1E2E35;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
}

.pnTipBox.el-popover .popper__arrow {
  border-right-color: #1E2E35;
}

.pnTipBox.el-popover .popper__arrow::after {
  border-right-color: #1E2E35;
}

.pnTipBox.el-popper[x-placement^=left] .popper__arrow {
  border-right-width: 0;
  border-left-color: #1E2E35;
}

.pnTipBox.el-popper[x-placement^=left] .popper__arrow::after {
  border-right-width: 0;
  border-left-color: #1E2E35;
}

// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    display: flex;
    align-items: center;
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {

  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00FEBB;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00FEBB;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00FEBB;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7B8395;
  }

  .el-month-table td .cell:hover {
    color: #00FEBB;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00FEBB;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7B8395;
  }

  .el-year-table td .cell:hover {
    color: #00FEBB;
  }
}

// 表格右侧边线
// .dataloggerManage {
//   .el-table--border::after, 
//   .el-table--group::after {
//     display: none;
//   }
// }
.tablemain.el-table--border::after {
  display: none;
}

.dataloggerManage {
  .scqsbAlert {

    .el-table--border::after,
    .el-table--group::after {
      display: block;
      background-color: #A3A9B5;
    }

    // 弹窗表格右侧边线
    .el-table--border {
      border-right: 1px solid #A3A9B5;
    }

    // 滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }

    // 加载数据时遮罩
    .el-loading-mask {
      background-color: transparent;
    }

    .el-loading-spinner i {
      color: @primaryTextColor;
    }
  }
}
</style>
